import { Component, OnInit, Renderer2, RendererFactory2 } from '@angular/core';
import { NavigationEnd, Event, Router, ActivatedRouteSnapshot } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Account } from './core/auth/account.model';
import { AccountService } from './core/auth/account.service';
import * as dayjs from 'dayjs';
import { Title } from '@angular/platform-browser';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakProfile } from 'keycloak-js';
import { LoginService } from './login/login.service';
import { BnNgIdleService } from 'bn-ng-idle'; // import it to your component

declare const $: any;
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
    title = 'DGTT';
    url: string;
    account: Account | null = null;
    private renderer: Renderer2;
    public isLoggedIn = false;
    public userProfile: KeycloakProfile | null = null;
    constructor(
        private bnIdle: BnNgIdleService,
        private readonly keycloak: KeycloakService,
        private titleService: Title,
        private translateService : TranslateService,private router: Router,private loginService  : LoginService,    rootRenderer: RendererFactory2
    ){






        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                const url = event.url.split('/');
                this.url = url[1];
                if (
                    event.url == '/login/login' ||
                    event.url == '/login/register' ||
                    event.url == '/login/forgot' ||
                    event.url == '/login/otp' ||
                    event.url == '/login/lockscreen'
                ) {
                    if (document!=null && document.querySelector('body')!=null)
                        document.querySelector('body').classList.add('account-page');
                } else {
                    if ( document.querySelector('body')!=null)
                        document.querySelector('body').classList.remove('account-page');
                }
                if (
                    event.url == '/error/error404' ||
                    event.url == '/error/error500'
                ) {
                    document.querySelector('body').classList.add('error-page');
                } else {
                    document.querySelector('body').classList.remove('error-page');
                }
            }
        });
    }
    private getPageTitle(routeSnapshot: ActivatedRouteSnapshot): string {
        const title: string = routeSnapshot.data['pageTitle'] ?? '';
        if (routeSnapshot.firstChild) {
            return this.getPageTitle(routeSnapshot.firstChild) || title;
        }
        return title;
    }
    private updateTitle(): void {
        let pageTitle = this.getPageTitle(this.router.routerState.snapshot.root);
        if (!pageTitle) {
            pageTitle = 'global.title';
        }
        this.translateService.get(pageTitle).subscribe(title => this.titleService.setTitle(title));
    }



    ngOnInit() {


        this.keycloak.isLoggedIn().then(x=>{

            if (!x){
                this.loginService.login();
            }
        });

        // Minified Sidebar



        this.bnIdle.
        
        
        startWatching(60).subscribe((isTimedOut: boolean) => {
            if (isTimedOut) {

                if (this.keycloak.isTokenExpired())
                {
                    this.keycloak.updateToken();
                }

            }
          });

        $(document).on('click', '#toggle_btn', () => {
            if ($('body').hasClass('mini-sidebar')) {
                $('body').removeClass('mini-sidebar');
                $('.subdrop + ul').slideDown();
            } else {
                $('body').addClass('mini-sidebar');
                $('.subdrop + ul').slideUp();
            }
            return false;
        });


        /*$(document).on('mouseover', (e: { stopPropagation: () => void; target: any; }) => {
          e.stopPropagation();
          if ($('body').hasClass('mini-sidebar') && $('#toggle_btn').is(':visible')) {
            const targ = $(e.target).closest('.sidebar').length;
            if (targ) {
              $('body').addClass('expand-menu');
              $('.subdrop + ul').slideDown();
            } else {
              $('body').removeClass('expand-menu');
              $('.subdrop + ul').slideUp();
            }
            return false;
          }
        });
    */
        $('body').append('<div class="sidebar-overlay"></div>');
        $(document).on('click', '#mobile_btn', function() {
            var $wrapper = $('.main-wrapper');
            $wrapper.toggleClass('slide-nav');
            $('.sidebar-overlay').toggleClass('opened');
            $('html').addClass('menu-opened');
            $('#task_window').removeClass('opened');
            return false;
        });

        $('.sidebar-overlay').on('click', function () {
            var $wrapper = $('.main-wrapper');
            $('html').removeClass('menu-opened');
            $(this).removeClass('opened');
            $wrapper.removeClass('slide-nav');
            $('.sidebar-overlay').removeClass('opened');
            $('#task_window').removeClass('opened');
        });
    }
}
